import { useState } from 'react';
import { ProductApi } from '@setvi/shared/enums/api/products';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { AxiosMethods } from '@setvi/shared/enums';

export const useRealTimeInventory = () => {
  const [loading, setLoading] = useState(false);
  const { token } = useAppContext();

  const fetchRealtimeInventory = async (id: string) => {
    setLoading(true);

    const baseURL = process.env.REVOPS_API;
    const endpoint = ProductApi.realtimeInventory.replace(':productId', id);
    const url = `${baseURL}${endpoint}`;

    try {
      const response = await fetch(url, {
        method: AxiosMethods.GET,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.ok) {
        return await response.json();
      }
    } finally {
      setLoading(false);
    }
  };

  return { fetchRealtimeInventory, loading };
};
